export const SettingKey = {
  units: 'units',
  failSafe: 'failsafe',
  deliveryMode: 'deliveryMode',
  rtkNtrip: 'rtkNtrip',
};

export const weatherSettingsKeys = [
  'visibility', 
  'windGust', 
  'windSpeed',
];

export const droneSettingsKeys = [
  'deliveryAltitude', 
  'deliverySpeed', 
  'flightAltitude', 
  'deliveryRadius', 
  'updateFrequency', 
  'geofenceWidth', 
  'failSafe', 
  'deliveryMode'
];

export const droneSettingsKeysToExclude = [
  'updateFrequency', 
  'geofenceWidth', 
];

export const excludeNtrip = [
  'ntripHost',
  'ntripPort',
  'ntripMountpoint',
  'ntripUsername',
  'ntripPassword',
];

export const NumericRanges: Record<string, { min: number; max: number }> = {
  deliveryAltitude: { min: -10000, max: 10000 },
  deliverySpeed: { min: 0, max: 100 },
  flightAltitude: { min: -10000, max: 10000 },
  minReturnAltitude: { min: -1000, max: 1000 },
  deliveryRadius: { min: 0, max: 10000000 },
  visibility: { min: 0, max: 50000 },
  windGust: { min: 0, max: 1000 },
  windSpeed: { min: 0, max: 1000 },
};
